<template>
  <div class="dropdown-options" v-if="showDropdown" @click.stop>
    <input
      v-if="searchable"
      v-model="state.searchQuery"
      class="dropdown-options__search"
      placeholder="Search..."
      @click.stop
    />
    <div
      class="dropdown-options__row"
      v-for="option in filteredOptions"
      :key="option.id"
      @click="() => handleSelectChange(option.id, option.value, option)"
    >
      <Button
        :buttonName="option.value"
        classes="blank"
        :dataToggle="useModalDataToggle ? 'modal' : ''"
        :onClick="() => {}"
      >
        <img :src="require(`@/assets/${option.icon}`)" v-if="option.icon" />
        &nbsp;&nbsp;
      </Button>
    </div>
  </div>
</template>
<script>
import Button from "@/components/button.vue";
import { reactive, computed, watch } from "@vue/composition-api";

const filterOptions = (options, query) => {
  if (!query) return options;
  const term = query.toLowerCase();
  return options.filter(({ value }) =>
    String(value).toLowerCase().includes(term)
  );
};

export default {
  name: "DropdownOptions",
  props: {
    options: Array,
    label: String,
    onSelected: Function,
    showDropdown: Boolean,
    useModalDataToggle: Boolean,
    searchable: {
      type: Boolean,
      default: false,
    },
  },
  setup(props) {
    const state = reactive({ searchQuery: "" });

    const filteredOptions = computed(() =>
      filterOptions(props.options, state.searchQuery)
    );

    watch(
      () => props.showDropdown,
      (open) => {
        if (!open) state.searchQuery = "";
      }
    );

    const handleSelectChange = (id, value, options) =>
      props.onSelected(id, value, options);

    return {
      state,
      filteredOptions,
      handleSelectChange,
    };
  },
  components: {
    Button,
  },
};
</script>
<style lang="scss">
.dropdown-options {
  background: #ffffff;
  box-shadow: 0px 0px 8px rgba(37, 40, 43, 0.12);
  border-radius: 3px;
  margin-top: 9px;
  position: absolute;
  z-index: 100;
  width: 100%;
  max-height: 280px;
  overflow-y: auto;

  &__search {
    width: calc(100% - 24px);
    margin: 12px;
    padding: 10px 12px;
    border: 1px solid #cbd2d9;
    border-radius: 4px;
    font-size: 14px;
    outline: none;

    &:focus {
      border-color: #e00b5b;
    }
  }
  .button-comp {
    width: 100%;
  }
  .btn {
    width: 100%;
  }
  .button-comp:first-child,
  .btn:first-child {
    border-radius: 3px;
  }
  &__row:hover,
  .blank:hover {
    background: #1d222c0f;
  }
  &__row {
    display: flex;
    align-items: center;
    cursor: pointer;
    img {
      margin-right: 5px;
    }
  }
}
</style>
